import { Typography, Stack, Avatar } from '@mui/material';
import React from 'react';

import { useRouter } from '../../hooks/useRouter';
import {
  UserPartialWithRelations,
  UserWithRelations,
} from '../../redux/ellipsisApi';
import ImageLoader from '../ui/ImageLoader';

export const returnProfilePicture = (
  user?: UserPartialWithRelations | UserWithRelations | null,
  email?: string
) => {
  if (user) {
    if (user.profilePicture && user.profilePicture.path) {
      return (
        <ImageLoader
          src={user.profilePicture.path}
          alt={`${user.name} profile picture`}
          objectFit={'cover'}
        />
      );
    } else if (user.name && user.name.length > 0) {
      return user.name[0];
    } else if (user.email && user.email.length > 0) {
      return user.email[0];
    }
  } else if (email) {
    return email[0];
  }
  return '';
};

interface OwnProps {
  user?: UserPartialWithRelations;
  email?: string;
  linkToProfile?: boolean;
  size?: string;
  profilePicture?: boolean;
  showName?: boolean;
  secondaryText?: string;
  typographyVariant?:
    | 'body1'
    | 'body2'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6';
  bold?: boolean;
  color?: string;
  privacyMode?: boolean;
}
const UserDisplayRender = (props: OwnProps) => {
  const {
    user,
    email,
    linkToProfile = true,
    size = 'm',
    profilePicture = true,
    showName = true,
    secondaryText = '',
    typographyVariant = 'body2',
    bold = false,
    color,
    privacyMode = false,
  } = props;

  const router = useRouter();

  const userClickHandler = () => {
    if (user && linkToProfile) {
      router.push(`/user-profile/${user.id}`);
    }
  };

  function shortenSurname(name: string, roles: string[]): string {
    const parts = name.split(' ');
    if (parts.length < 2 || roles.includes('owner')) {
      return name;
    }
    return `${parts[0]} ${parts[1].charAt(0)}`;
  }

  return (
    <Stack
      onClick={userClickHandler}
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ cursor: linkToProfile ? 'pointer' : 'default' }}
    >
      {profilePicture && (
        <Avatar
          sx={{
            fontSize: size === 's' ? 13 : 15,
            height: size === 's' ? 24 : 40,
            width: size === 's' ? 24 : 40,
          }}
        >
          {returnProfilePicture(user, email)}
        </Avatar>
      )}
      {showName && (
        <Stack spacing={2}>
          <Typography
            variant={typographyVariant}
            sx={{
              fontWeight: bold ? 'bold' : undefined,
              color,
              fontSize: size === 's' ? 12 : size === 'unset' ? 'unset' : 15,
            }}
          >
            {privacyMode
              ? shortenSurname(user?.name ?? 'Anonymous', user?.roles ?? [])
              : (user?.name ?? user?.email ?? email ?? '')}
          </Typography>
          {secondaryText && (
            <Typography
              variant="body2"
              sx={{
                fontSize: size === 's' ? 10 : size === 'unset' ? 'unset' : 12,
                color,
              }}
            >
              {secondaryText}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default UserDisplayRender;
